import { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import { IPayrollShuttleEntry } from "../../interface/payrollShuttle";
import PayrollShuttleEntryTable, { EditablePayrollField } from "./PayrollShuttleEntryTable";
import PayrollShuttleDetailsTable from "./PayrollShuttleDetailsTable";

export type { EditablePayrollField };

interface PayrollShuttleTableProps {
    rows: IPayrollShuttleEntry[];
    onFieldChange: (id: string, field: EditablePayrollField, value: string | number) => void;
}

export default function PayrollShuttleTable({ rows, onFieldChange }: PayrollShuttleTableProps) {
    const [activeTab, setActiveTab] = useState(0);

    return (
        <Box>
            <Tabs value={activeTab} onChange={(_, value) => setActiveTab(value)} sx={{ mb: 2, borderBottom: "1px solid #e2e8f0" }}>
                <Tab label="Saisie manuelle" />
                <Tab label="Détails calculés" />
            </Tabs>

            {activeTab === 0
                ? <PayrollShuttleEntryTable rows={rows} onFieldChange={onFieldChange} />
                : <PayrollShuttleDetailsTable rows={rows} />
            }
        </Box>
    );
}
